var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('app-header'):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }